export function toggleExclusiveOpen(current, next) {
  return current === next ? null : next;
}
